import React, { useEffect, useState } from "react";
import { ClockIcon, UsersIcon } from "lucide-react";
const TOTAL_CUPOS = 200;
export function CountdownUrgency() {
  // 23h countdown persisted-ish for the session
  const [secondsLeft, setSecondsLeft] = useState(6 * 3600 + 42 * 60 + 18);
  const [cuposLeft] = useState(37); // out of 200

  useEffect(() => {
    const t = setInterval(() => {
      setSecondsLeft(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(t);
  }, []);
  const h = Math.floor(secondsLeft / 3600);
  const m = Math.floor(secondsLeft % 3600 / 60);
  const s = secondsLeft % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  const pct = Math.round(cuposLeft / TOTAL_CUPOS * 100);
  return <div className="rounded-2xl border border-[#c7a24a]/50 bg-[#1f4d3a] p-4 text-white" data-id="element-145" data-mp="1w4gqri8mzf0m">
      <div className="mb-3 flex items-center justify-center gap-2 text-sm font-semibold text-[#f4e3b6]" data-id="element-146" data-mp="6psgpnniq95r">
        <ClockIcon className="h-4 w-4" data-id="element-147" data-mp="1rh79e14y0o2" />
        La oferta termina en
      </div>
      <div className="mb-4 flex items-center justify-center gap-2" data-id="element-148" data-mp="2jsckstzczjw6">
        {[{
        v: pad(h),
        l: "hrs"
      }, {
        v: pad(m),
        l: "min"
      }, {
        v: pad(s),
        l: "seg"
      }].map((b, i) => <React.Fragment key={b.l} data-id="element-149" data-mp="2sqetlvpc3gu0" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-150" data-mp="2sq54sbg0zfpw">
              <span className="min-w-[46px] rounded-lg bg-white/10 px-2 py-2 text-center text-2xl font-black tabular-nums text-white" data-id="element-151" data-mp="2xjhms2q78o9o">
                {b.v}
              </span>
              <span className="mt-1 text-[10px] uppercase tracking-widest text-white/60" data-id="element-152" data-mp="37g2vay1fghi9">
                {b.l}
              </span>
            </div>
            {i < 2 && <span className="text-2xl font-black text-[#c7a24a]" data-id="element-153" data-mp="3ce4av8zn9yoz">:</span>}
          </React.Fragment>)}
      </div>

      <div className="flex items-center justify-between text-xs font-semibold text-white/80" data-id="element-154" data-mp="1i2fvx6texw4l">
        <span className="flex items-center gap-1" data-id="element-155" data-mp="1m39hhtjduyub">
          <UsersIcon className="h-4 w-4 text-[#c7a24a]" data-id="element-156" data-mp="1m3t2jj4by3ck" /> Cupos restantes
        </span>
        <span className="text-[#f4e3b6]" data-id="element-157" data-mp="2pf8b8i8jkpht">
          {cuposLeft} / {TOTAL_CUPOS}
        </span>
      </div>
      <div className="mt-2 h-3 w-full overflow-hidden rounded-full bg-white/15" data-id="element-158" data-mp="2kgwynzqv40vw">
        <div className="h-full rounded-full bg-[#c7a24a] transition-all" style={{
        width: `${pct}%`
      }} data-id="element-159" data-mp="2yg6gt4ymp52i" />
      </div>
      <p className="mt-2 text-center text-[11px] text-white/60" data-id="element-160" data-mp="2ufw9noz3o8m2">
        ¡Se agotan rápido! Quedan pocos cupos con este precio.
      </p>
    </div>;
}